import api from "./apiURL";

export const getSupportQuerys = async () => {
    try {
        const response = await api.get(`api/v1/support/get`);
        return response.data;
    } catch (error) {
        // Handle the error
        console.log(error);
    }
};

export async function UpdateComplaint(data) {
    try {
        const response = await api.post("api/v1/support/add", data);
        return response.data;
    } catch (error) {
        console.log(error);
        // handle error
        return null;
    }
}

export async function addMessage(data) {
    try {
        const response = await api.put("api/v1/support/message", data);
        return response.data;
    } catch (error) {
        console.log(error);
        // handle error
        return null;
    }
}

export async function updateSeen(data) {
    try {
        const response = await api.put(`/api/v1/support/message/seen`, data);
        return response.data;
    } catch (error) {
        // Handle the error
        console.log(error);
    }
}
